import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ConfigService } from '@xilo-mono/common/config';
import { xml2json } from 'xml-js';
import { get } from 'lodash';
@Injectable()
export class VehicleListService {
  VEHICLE_LIST_URL = `${this.configService.apiUrl}/vehicle-list`;
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {}

  /* EZLYNX */
  getEZYears() {
    return this.http
      .get(`${this.VEHICLE_LIST_URL}/ezlynx/years`)
      .pipe(map((result: { body }) => result.body));
  }

  getEZMakes(year: string) {
    return this.http
      .get(`${this.VEHICLE_LIST_URL}/ezlynx/makes/${year}`)
      .pipe(map((result: { body }) => result.body));
  }

  getEZModels(year: string, make: string) {
    make = encodeURIComponent(make)
    return this.http
      .get(`${this.VEHICLE_LIST_URL}/ezlynx/models/${year}/${make}`)
      .pipe(map((result: { body }) => result.body));
  }

  getEZSubModels(year: string, make: string, model: string) {
    make = encodeURIComponent(make)
    model = encodeURIComponent(model)
    return this.http
      .get(
        `${this.VEHICLE_LIST_URL}/ezlynx/sub-models/${year}/${make}/${model}`
      )
      .pipe(map((result: { body }) => result.body));
  }

  getEZVehicleByVin(vin: string) {
    try {
      return this.http.get(`${this.VEHICLE_LIST_URL}/ezlynx/vin/${vin}`).pipe(
        map((result: { body }) => {
          const rawData = result.body;
          const parsedVehicle = this.parseVinXml(rawData);
          const vehicleResult = get(
            parsedVehicle,
            'soap:Envelope.soap:Body.VINValidateResponse.VINValidateResult'
          );
          let vehicleResultData = get(
            vehicleResult,
            'VehicleResults.VehicleResult'
          );
          if (!vehicleResultData) {
            console.error('No vehicle found');
            return null;
          }
          if (!Array.isArray(vehicleResultData)) {
            vehicleResultData = [vehicleResultData];
          }

          return vehicleResultData.map(vehicleData => {
            const obj = {
              Status: vehicleResult?.Result?._text,
              VIN: vehicleData?.VIN?._text,
              Make: vehicleData?.Make?._text,
              Model: vehicleData?.Model?._text,
              Year: Number(vehicleData?.Year?._text),
              BodyStyle: vehicleData?.BodyStyle?._text,
              Drive: vehicleData?.Drive?._text,
              EngineInfo: vehicleData?.EngineInfo?._text,
              CombinedBody: vehicleData?.BodyStyle?._text,
              Transmission: vehicleData?.Transmission?._text,
              AntilockBrakes: vehicleData?.AntilockBrakes?._text,
              SecuritySystem: vehicleData?.SecuritySystem?._text,
              DaytimeRunningLights: vehicleData?.DaytimeRunningLights?._text,
              TonRating: vehicleData?.TonRating?._text,
              Restraint: vehicleData?.Restraint?._text,
              Country: vehicleData?.Country?._text,
              BaseListPrice: vehicleData?.BaseListPrice?._text,
              Fuel: vehicleData?.Fuel?._text,
              rawData: rawData,
            };
            if (obj.Drive) {
              obj.CombinedBody += ` ${obj.Drive}`;
            }
            if (obj.EngineInfo) {
              obj.CombinedBody += ` ${obj.EngineInfo}`;
            }
            return obj;
          });
        })
      );
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  parseVinXml(rawData: string) {
    const obj = xml2json(rawData, { compact: true });
    return typeof obj === 'string' ? JSON.parse(obj) : obj;
  }

  getVehicleYears() {
    return this.http
      .get(`${this.VEHICLE_LIST_URL}/years`)
      .pipe(map((result: { body }) => result.body));
  }

  getVehicleMakes(type: string, year: string) {
    return this.http
      .get(`${this.VEHICLE_LIST_URL}/makes/${type}/${year}`)
      .pipe(map((result: { body }) => result.body));
  }

  getVehicleModels(type: string, year: string, make: string) {
    make = encodeURIComponent(make);
    return this.http
      .get(`${this.VEHICLE_LIST_URL}/models/${type}/${year}/${make}`)
      .pipe(map((result: { body }) => result.body));
  }

  getVehicleBodyStyles(type: string, year: string, make: string, model: string) {
    make = encodeURIComponent(make);
    model = encodeURIComponent(model);
    return this.http
      .get(`${this.VEHICLE_LIST_URL}/body-styles/${type}/${year}/${make}/${model}`)
      .pipe(map((result: { body }) => result.body));
  }
}